import React from "react";
import {ValidateStep2Data} from "@validators/business-insurance-form/step2-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";


export default function IF_Step2(
   {
      data,
      handlers,
      setCurrentStep,
      handlePolicyHolderAccidentPropChange,
      addPolicyHolderAccident,
      removePolicyHolderAccident,
   }
) {
   
   const onPrevBtnClick = (event) => {
      
      setCurrentStep(1);
      
   }
   
   function onNextBtnClick() {
      
      let validationResult = ValidateStep2Data(data);
      
      /*validationResult.push({
          name : 'halt',
          message : 'Halt further processing'
      });*/
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         });
         
         
      } else {
         setCurrentStep(3);
      }
      
      
   }
   
   
   
   return (
      <div className='if-step-2'>
         
         <SectionHeading
            text="Business/Trade Address"
         />
         
         <div className="row">
            
            {/* House number */}
            
            <ScrollableTextBoxBlock
               value={data.businessHouseNumber}
               containerCssClass="col-12 py-3"
               labelText="House number"
               required={true}
               controlName="businessHouseNumber"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Street address */}
            
            <ScrollableTextBoxBlock
               value={data.businessStreetAddress}
               containerCssClass="col-12 py-3"
               labelText="Street address"
               required={true}
               controlName="businessStreetAddress"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Post code */}
            
            <ScrollableTextBoxBlock
               value={data.businessPostCode}
               containerCssClass="col-12 py-3"
               labelText="Post code"
               required={true}
               controlName="businessPostCode"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 10
               }}
            />
            
            {/* Year established */}
            
            <ScrollableTextBoxBlock
               value={data.businessYearEstablished}
               containerCssClass="col-12 py-3"
               labelText="Year established at this address since"
               required={true}
               controlName="businessYearEstablished"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 4
               }}
            />
         
         </div>
         
         <SectionHeading
            text="Correspondence address"
            headingCssClass={`mt-3`}
         />
         
         <div className="row">
            
            {/* House number */}
            
            <ScrollableTextBoxBlock
               value={data.correspondentHouseNumber}
               containerCssClass="col-12 py-3"
               labelText="House number"
               required={false}
               controlName="correspondentHouseNumber"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Street address */}
            
            <ScrollableTextBoxBlock
               value={data.correspondentStreetAddress}
               containerCssClass="col-12 py-3"
               labelText="Street address"
               required={false}
               controlName="correspondentStreetAddress"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Post code */}
            
            <ScrollableTextBoxBlock
               value={data.correspondentPostCode}
               containerCssClass="col-12 py-3"
               labelText="Post code"
               required={false}
               controlName="correspondentPostCode"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 10
               }}
            />
            
         </div>
         
         
         <WizardStepButtonsBlock
            onPrevBtnClick={onPrevBtnClick}
            onNextBtnClick={onNextBtnClick}
            nextButtonAdditionalCssClass={``}
         />
      
      
      </div>
   )
}